import React from "react";
import "./styles.scss";

const Index = () => {
  return (
    <div className="mhw_sw_footer_wrapper">
      By signing up, you agree to our{" "}
      <div>
        <span className="sw_fw_highlight">Terms of Service</span> and{" "}
        <span className="sw_fw_highlight">Privacy Policy.</span>
      </div>
    </div>
  );
};

export default Index;
